import React from "react";
import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    List,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";

const SidebarSection = ({ open, title, items, isOpen, onToggle }) => {
    const navigate = useNavigate();

    const handleItemClick = (route) => {
        // Special case for talent-dashboard to reset to history view
        if (route === "talent-dashboard") {
            navigate(`/dashboard/${route}?reset=true`);
        } else {
            navigate(`/dashboard/${route}`);
        }
    };

    return (
        <>
            <ListItem
                button
                onClick={onToggle}
                sx={{ "&:hover": { backgroundColor: "#FFC700" } }}
            >
                <ListItemIcon>{items[0].icon}</ListItemIcon>
                <ListItemText
                    primary={title}
                    sx={{ display: open ? "block" : "none" }}
                />
                {open && (isOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItem>
            <Collapse in={isOpen && open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {items.map((item) => (
                        <ListItem
                            key={item.name}
                            button
                            sx={{
                                pl: 4,
                                "&:hover": { backgroundColor: "#FFC700" },
                                backgroundColor: item.selected
                                    ? "#FFC700"
                                    : "transparent",
                            }}
                            onClick={() => handleItemClick(item.route)}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.name} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

export default SidebarSection;
